import { render, staticRenderFns } from "./settings-organization-schedule.vue?vue&type=template&id=9237369e&scoped=true&"
import script from "./settings-organization-schedule.vue?vue&type=script&lang=js&"
export * from "./settings-organization-schedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9237369e",
  null
  
)

export default component.exports